<template>
    <div>
        <CheckboxVue v-model:check="checkTermAndPrivacy">
            <div class="text-a-brown-502314 text-16">
                {{lbl.register.warnning_next}}
                <span class="text-a-red-d62300 underline cursor-pointer" @click="clickTerm()">{{lbl.register.term}}</span>
                {{lbl.register.warnning_next_2}}
                <span class="text-a-red-d62300 underline cursor-pointer" @click="clickPrivacy()">{{lbl.register.privacy}}</span>
                {{lbl.register.warnning_next_3}}
            </div>
        </CheckboxVue>
        <CheckboxVue v-model:check="checkMarket">
            <div class="text-a-brown-502314 text-16">
                {{lbl.register.term_market_1}}
                <span class="text-a-red-d62300 underline cursor-pointer" @click="clickMKT()">{{lbl.register.term_market_2}}</span>
            </div>
        </CheckboxVue>
        <div class="text-a-brown-502314 text-16 mt-3">
            {{lbl.register.term_cancel}}
            <a class="text-a-red-d62300 underline cursor-pointer" href="mailto:privacy.Food@minor.com">Privacy.Food@minor.com</a>
        </div>
        <!-- <div class="text-a-brown-502314 text-16 mt-6">
            {{lbl.register.warnning_next}}
            <span class="text-a-red-d62300 underline cursor-pointer" @click="clickTerm()">{{lbl.register.term}}</span>
            {{lbl.register.warnning_next_2}}
            <span class="text-a-red-d62300 underline cursor-pointer" @click="clickPrivacy()">{{lbl.register.privacy}}</span>
            {{lbl.register.warnning_next_3}}
        </div> -->
    </div>
</template>
<script>
import CheckboxVue from '@/components/Input/simple/Checkbox.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';

export default {
    mixins: [LocaleMixin, ModalMixin],
    components: {
        CheckboxVue,
    },
    data: function () {
        return {
            checkMarket: false,
            checkTermAndPrivacy: false,
        };
    },
    watch: {
        checkMarket: function () {
            this.$emit('onMarketAcceptChange', this.checkMarket);
        },

        checkTermAndPrivacy: function () {
            this.$emit('onTermAcceptChange', this.checkTermAndPrivacy);
        }
    },
    methods: {
        clickTerm: function () {
            // this.$router.push("/terms");
            this.modal.pdpaModal.clearModal()
                .setTitle(this.lbl.register.term)
                .setType('terms')
                .show();
        },
        clickPrivacy: function () {
            // this.$router.push("/privacy");
            this.modal.pdpaModal.clearModal()
                .setTitle(this.lbl.register.privacy)
                .setType('privacy')
                .show();
        },
        clickMKT: function () {
            window.location.href = "https://www.minorfood.com/th/privacy/companies";
        }
    }

}
</script>
<style lang="scss" scoped>
</style>
